export class KeyConnectorUserKeyRequest {
  key: string;

  constructor(key: string) {
    this.key = key;
  }
}
